import React, { useState, useEffect } from 'react';
import { Box, Flex, Button, Text, HStack, Spacer, IconButton } from "@chakra-ui/react";
import { TbGolf } from 'react-icons/tb';
import { useSwipeable } from 'react-swipeable';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

const Bay = ({ bayNumber, selectedBay, setSelectedBay }) => (
  <Box
    w="full"
    maxW="sm"
    mx={2}
    px={4}
    py={4}
    rounded="lg"
    bg={bayNumber === selectedBay ? 'rgba(130, 202, 156, 0.1)' : 'white'}
    onClick={() => setSelectedBay(bayNumber)}
    cursor="pointer"
    transition="all 0.2s"
    boxShadow={bayNumber === selectedBay ? "0 4px 12px rgba(130, 202, 156, 0.2)" : "0 2px 6px rgba(0, 0, 0, 0.05)"}
    _hover={{
      boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
      transform: "translateY(-3px)",
    }}
  >
    <Flex justifyContent="center" alignItems="center">
      <Text fontSize="md" color="gray.600" fontWeight="500">Bay</Text>
    </Flex>
    <Box display="flex" justifyContent="center">
      <Text 
        fontSize="2xl" 
        fontWeight="bold" 
        mt={2} 
        color={bayNumber === selectedBay ? '#82ca9c' : 'gray.800'}
      >
        {bayNumber}
      </Text>
    </Box>
    <Box>
      <Flex alignItems="center" mt={2} color="gray.700"></Flex>
    </Box>
  </Box>
);

const BayBooking = ({ onBayChange }) => {
  const totalBays = 3;
  const baysPerPage = 3;
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedBay, setSelectedBay] = useState(1);

  useEffect(() => {
    if (selectedBay !== null) {
      onBayChange(selectedBay);
    }
  }, [selectedBay, onBayChange]);

  const handleScrollNext = () => setCurrentPage((currentPage + 1) % Math.ceil(totalBays / baysPerPage));
  const handleScrollPrev = () => setCurrentPage((currentPage - 1 + Math.ceil(totalBays / baysPerPage)) % Math.ceil(totalBays / baysPerPage));

  const currentBaysStart = currentPage * baysPerPage + 1;
  const currentBaysEnd = Math.min((currentPage + 1) * baysPerPage, totalBays);

  const handlers = useSwipeable({
    onSwipedLeft: () => handleScrollNext(),
    onSwipedRight: () => handleScrollPrev(),
  });

  return (
    <Box 
      {...handlers} 
      borderRadius="lg"
      p={4}
      mt={4}
      bg="white"
      boxShadow="0 4px 12px rgba(0, 0, 0, 0.05)"
    >
      <HStack marginBottom={4}>
        <TbGolf color="#82ca9c" fontSize={20} />
        <Text fontWeight="600">Select a bay</Text>
        <Spacer />
      </HStack>
      
      <HStack justify="space-between" mb={4}>
        <HStack>
          <IconButton 
            icon={<ChevronLeftIcon />}
            onClick={handleScrollPrev}
            size="sm"
            variant="ghost"
            colorScheme="green"
            borderRadius="full"
            h="32px"
            minW="32px"
            p={0}
          />
          <Text fontWeight="medium" px={2}>Bay {currentBaysStart}-{currentBaysEnd}</Text>
          <IconButton 
            icon={<ChevronRightIcon />}
            onClick={handleScrollNext}
            size="sm"
            variant="ghost"
            colorScheme="green"
            borderRadius="full"
            h="32px"
            minW="32px"
            p={0}
          />
        </HStack>
      </HStack>
      
      <Box 
        bg="#f8f9fa" 
        borderRadius="md" 
        py={3} 
        px={2}
      >
        <Flex 
          direction="row" 
          justifyContent="space-between"
        >
          {[...Array(baysPerPage)].map((_, i) => {
            const bayNumber = currentPage * baysPerPage + i + 1;
            if (bayNumber > totalBays) return null;
            return <Bay key={bayNumber} bayNumber={bayNumber} selectedBay={selectedBay} setSelectedBay={setSelectedBay} />;
          })}
        </Flex>
      </Box>
    </Box>
  );
};

export default BayBooking;